/**
 * 空状态展示组件 v2 — 对齐视觉基线 §4.5 空态三要素。
 *
 * 结构：图标 + 标题 + 来源说明（12px）+ 引导按钮；整体高度 ≤240px。
 * v2 新增可选 props（全部向后兼容，旧调用不受影响）：
 * - source：数据来自哪个引擎/任务（如"由洞悉引擎周期探测产出"）
 * - action：引导按钮 { label, onClick }
 * - hint：底部补充提示（弱化）
 */
import { Box, Button, Typography } from "@mui/material";
import { InboxOutlined } from "@mui/icons-material";

export interface EmptyStateProps {
  /** 提示文字（标题）。 */
  text?: string;
  /** 副标题。 */
  subtitle?: string;
  /** 图标大小。 */
  iconSize?: number;
  /** 来源说明（12px）：数据由哪个引擎/任务产出。 */
  source?: string;
  /** 引导按钮。 */
  action?: { label: string; onClick: () => void };
  /** 底部补充提示（弱化，11px）。 */
  hint?: string;
}

export default function EmptyState({
  text = "暂无数据",
  subtitle,
  iconSize = 48,
  source,
  action,
  hint,
}: EmptyStateProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: 3,
        maxHeight: 240,
        boxSizing: "border-box",
      }}
    >
      <InboxOutlined
        sx={{ fontSize: iconSize, color: "text.disabled", mb: 1 }}
      />
      <Typography sx={{ fontSize: 14, fontWeight: 500, color: "grey.700" }}>
        {text}
      </Typography>
      {subtitle && (
        <Typography sx={{ fontSize: 12, color: "text.disabled", mt: 0.5 }}>
          {subtitle}
        </Typography>
      )}
      {source && (
        <Typography sx={{ fontSize: 12, color: "text.secondary", mt: 0.5 }}>
          {source}
        </Typography>
      )}
      {action && (
        <Button
          size="small"
          variant="outlined"
          onClick={action.onClick}
          sx={{ mt: 1.5, fontSize: 12 }}
        >
          {action.label}
        </Button>
      )}
      {hint && (
        <Typography sx={{ fontSize: 11, color: "text.disabled", mt: 1 }}>
          {hint}
        </Typography>
      )}
    </Box>
  );
}
